/**
 * Authenticates the user being logged in to acces specific routes, else route
 * to login form
 */
import React from 'react';
import { Redirect, Route, useLocation } from 'react-router-dom';

function PrivateRoute({ component: Component, render, ...rest }) {
  const { isLoggedIn } = rest;
  const { isSSOLoggedIn } = rest;
  const { currentUser } = rest;
  const { allowedRoles } = rest;
  const location = useLocation();
  const isCreatorsDomain = window.location.hostname.includes('creators');

  let hasAccess = true;
  if (allowedRoles && allowedRoles.length > 0) {
    hasAccess = allowedRoles.includes(currentUser.role);
  }

  if (!isLoggedIn && !isSSOLoggedIn) {
    const renderedContent = () => (
      <Redirect
        to={{
          pathname: isCreatorsDomain ? '/influencer-login' : '/login',
          state: { from: location },
        }}
      />
    );
    return <Route {...rest} render={renderedContent} />;
  }
  if (!hasAccess) {
    const renderedContent = () => (
      <div>You are not authorized to access this page.</div>
    );
    return <Route {...rest} render={renderedContent} />;
  }

  if (render) {
    return (
      <Route {...rest} render={(props) => render({ currentUser, ...props })} />
    );
  }
  const renderedContent = (props) => (
    <Component currentUser={currentUser} {...props} />
  );
  return <Route {...rest} render={renderedContent} />;
}

const PrivateRouteMemo = React.memo(PrivateRoute);

export default PrivateRouteMemo;
